import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { toast } from "react-toastify";
import IsLoadingHOC from "./IsLoadingHOC";
import { authAxios } from "../config/config";

const VerifyOtp = ({ setLoading }) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
     setLoading(true);
    const Email = sessionStorage.getItem("email");
    const payload = {
      email: Email.toLowerCase(),
      enteredOTP: Number(otp),
    };
    await authAxios()
      .post(`/auth/verify-otp`, payload)
      .then((response) => {
        const resData = response?.data;
         setLoading(false);
        if (resData.status === 1) {
          toast.success(resData?.message);
          navigate('/set-password');
        } else {
          toast.error(resData?.message);
        }
      })
      .catch((error) => {
         setLoading(false);
        toast.error(error?.response?.data?.message||error?.message);
      });
  };

  // Helper function to handle number-only input
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { // Only allow digits
      setOtp(value);
    }
  };

  return (
    <div className="flex shadow-lg flex-1 flex-col justify-center px-5 py-6 rounded-[20px] lg:px-5 bg-white border max-w-[400px] mx-auto absolute w-[95%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
      <div className="sm:mx-auto sm:w-full">
        <img
          className="mx-auto h-20 w-auto"
          src="./assets/images/final-logo.png"
          alt="Your Company"
        />
        <h2 className="mt-2 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Verify One time password
        </h2>
      </div>

      <div className="mt-5 sm:mx-auto sm:w-full ">
        <form onSubmit={handleVerifyOtp} className="space-y-6">
          <div>
            <label
              htmlFor="verifyotp"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              OTP
            </label>
            <div className="mt-2">
              <input
                id="verifyotp"
                name="verifyotp"
                type="tel"
                value={otp}
                onChange={handleInputChange}
                required
                pattern="\d*"
                maxLength={6} // You can set the maximum length of OTP digits here
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IsLoadingHOC(VerifyOtp);
